import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { HttpErrorResponse } from "@angular/common/http";
import { Observable, Subject } from 'rxjs';

import { SubjectRelay } from '../../../../shared/commands/subject-relay.class';

import { PlanPreventionEntity } from '../../entities/plan-prevention.entity';

import { PlanPreventionService } from '../../services/plan-prevention.service';

@Component({
	selector: 'pdp-manage-link',
	templateUrl: 'pdp-manage-link.html',
	styleUrls: ['pdp-manage-link.css'],
})
export class PdpManageLinkComponent {
	
	// Gestion globale de la fenetre
	displaySubject = new Subject<boolean>();
	planPrevention!: PlanPreventionEntity;
	link: string = '';
	
	waitingForServer: boolean = false;
	
	constructor(@Inject(PlanPreventionService) private planPreventionService: PlanPreventionService) {
		// Lors de la reception d'une demande de signature de pdp
		this.manageCommandsSubject.subscribe(
			(data) => {
				// faire les affectations puis afficher la fenetre
				this.waitingForServer = false;
				this.planPrevention = data;
				this.link = data.lien;
				this.displaySubject.next(true);
			}
 		);
	}

	@Input() id = 'pdpManageLinkDialog';
	
	// Liaison de l'observable servant a commander l'affichage du composant
	private manageCommandsSubject = new SubjectRelay<PlanPreventionEntity>();
	@Input() set manageCommands(obs: Observable<PlanPreventionEntity> | undefined) {
		this.manageCommandsSubject.registerSource(obs);
	}

	// Evenements de changement sur le pdp
	@Output() pdpChanged = new EventEmitter<number>();
	
	onCloseRequested() {
		this.cleanAndClose();
	}
	
	private cleanAndClose() {
		this.displaySubject.next(false);
		this.pdpChanged.emit(this.planPrevention?.id);
	}
	
	onSaveRequested() {
		this.waitingForServer = true;
		console.log('maj du lien sur le serveur');
		if (this.planPrevention) {
			this.planPrevention.lien = this.link;
			this.planPreventionService.updateLink(this.planPrevention).subscribe(
				(result) => {
						this.waitingForServer = false;
						this.cleanAndClose();
				},
				(httpErrorResponse: HttpErrorResponse) => {
					this.waitingForServer = false;
					console.log(httpErrorResponse);
					alert('La mise à jour du lien n\'a pas pu être réalisé à cause d\'un problème technique');
				}
			);
		}
	}

}